import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/274'

const EmailEngagementByCampaignTypeTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="thanx_campaigns.performance.emailEngagementByCampaignType"
  />
)

export default EmailEngagementByCampaignTypeTab
